import { Component, OnInit } from '@angular/core';
import { AuthentictionService } from '../../services/authentiction.service';
import { UtilService } from '../../services/util.service';
import { NgForm } from '@angular/forms';
import { Constant } from '../../services/data';
import { Router } from '@angular/router';
import { PlaylistService } from '../../services/playlist.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MessageService } from '../../services/message.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-mu3-login',
  templateUrl: './mu3-login.component.html',
  styleUrls: ['./mu3-login.component.css']
})
export class Mu3LoginComponent implements OnInit {

  playListModal: any = {
    type: 'fromUrl',
    name: '',
    userName: '',
    password: '',
    url: ''
  };

  playList: any = [];
  xstreamList: any;
  isLoading: boolean = false;
  userid:any;
  filterPlayList:any= [];
  // bsModalRef: BsModalRef;
  url_pattern = "([a-z0-9-]+\:\/+)([^\/\s]+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";

  // XuserId: any;
  constructor(private utilService: UtilService, private playlistService: PlaylistService, private modalService: BsModalService, private messageService: MessageService, private router: Router) {
  }

  ngOnInit(): void {
    const UserData = JSON.parse(this.utilService.getFullUserId()) || '';
    console.log(UserData,'local storage');
    
    this.userid = UserData.user_id
    // this.playListModal.type = "onestreamUrl"
    if (this.userid) {
      console.log(this.userid,'onin');
      this.getPlayList();
    }
  }
  getPlayList() {
    this.playList = [];
    let passModel: any = {
      userid: ''
    };
   
    passModel.userid = this.utilService.getFullUserId();
    
    this.utilService.showSpinner()

    this.isLoading = true;
    this.playlistService.getNewPlaylist().subscribe((res:any) =>{
      if(res.status === 'success'){
        console.log(res);
        this.playList = res.data
        this.filterPlayList = res.data
        this.isLoading = false;
        const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        this.filterPlayList = [...this.filterPlayList, ...localPlaylists];
        console.log(this.filterPlayList,'asdf');
        this.utilService.hideSpinner();
      }
    },err =>{
      this.isLoading = false;
      this.utilService.hideSpinner();
    })
  }

  checkDuplicateName(name) {
    let found = false;
    const inputName = name.toLowerCase();
    for (let index = 0; index < this.filterPlayList.length; index++) {
      const existingName = this.filterPlayList[index].playlist_name.toLowerCase();
      if (existingName === inputName) {
        found = true;
        this.utilService.showErrorToast('', 'Playlist name must be unique');
        break;
      }
    }
    return !found;
  }
  

  addPlaylistM3u(form: NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      let passModel: any = {
        type:2,
        url: this.playListModal.url,
        name: this.playListModal.name,
        // userid: this.utilService.getFullUserId()
      };
      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5 && this.userid){ 
        this.playlistService.addPlaylistM3u(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            this.utilService.showErrorSuccess('m3u playlist is added successfully');
            this.getPlayList();
            this.router.navigate(['/playlist'])
            this.playListModal.url = '';
            this.playListModal.name = '';
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
          this.utilService.showErrorToast(err.error.message); // show the error 
          
        });
        
      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            m3u_url: passModel.url,
            username: null,
            password: null,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };
  
        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);

        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);
        this.router.navigate(['/playlist'])
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
        };
      }
    }
  }

}
